import { render, staticRenderFns } from "./Jan_2022.vue?vue&type=template&id=d250b956&scoped=true&"
import script from "./Jan_2022.vue?vue&type=script&lang=js&"
export * from "./Jan_2022.vue?vue&type=script&lang=js&"
import style0 from "./Jan_2022.vue?vue&type=style&index=0&id=d250b956&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d250b956",
  null
  
)

export default component.exports